export default __webpack_public_path__ + "static/media/10000.c6b8c2f2.png";